import { ISO_8601_DATE_FORMAT as a } from "../constants/date.es.js";
const f = (e, t, r) => {
  const n = new Date(e, t, r);
  return !(isNaN(n.getTime()) || r !== n.getDate() || t + 1 !== n.getMonth() + 1 || e !== n.getFullYear());
};
function i(e, t) {
  if (!e)
    return "";
  const r = (s) => s < 10 ? "0" + s : s, n = {
    YYYY: e.getFullYear(),
    MM: r(e.getMonth() + 1),
    DD: r(e.getDate()),
    hh: r(e.getHours()),
    mm: r(e.getMinutes()),
    ss: r(e.getSeconds())
  };
  return t.replace(/YYYY|MM|DD|hh|mm|ss/g, (s) => n[s]);
}
function o(e) {
  var t = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])(T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(\.\d{3})?(Z|[+-]\d{2}:\d{2}))?$/;
  if (!t.test(e))
    return !1;
  var r = new Date(e);
  return !isNaN(r.getTime());
}
function D(e, t) {
  if (!e || !t)
    return !1;
  const r = {
    "DD/MM/YYYY": /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/,
    "MM/DD/YYYY": /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/\d{4}$/,
    "YYYY/MM/DD": /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])$/
  };
  return t in r ? r[t].test(e) : !1;
}
function c(e) {
  if (!e)
    return !1;
  const t = i(new Date(e), a);
  return o(t);
}
function Y(e) {
  if (!e)
    return !1;
  var t = /^(0?[0-9]|1[0-2]):([0-5]\d)$/;
  return t.test(e);
}
const l = (e) => e.toLocaleDateString("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric"
}), g = (e) => {
  if (e != null && e.indexOf("-")) {
    const [t, r, n] = e.split("-").map(Number);
    return new Date(t, r - 1, n);
  }
}, m = (e, t) => new Date(e, t, 0).getDate();
export {
  f as checkDateExistence,
  g as dateFromString,
  i as formatDate,
  m as getLastDayOfMonth,
  c as isValidDate,
  D as isValidDateFormat,
  Y as isValidTime,
  l as toHumanDate
};
//# sourceMappingURL=date.es.js.map
